export default {
  generic: {
    title: "Une erreur est survenue",
    message: "Une erreur inattendue s'est produite. Veuillez réessayer.",
    retry: "Réessayer",
    contact: "Si le problème persiste, contactez le support."
  },
  network: {
    title: "Erreur réseau",
    offline: "Vous êtes hors ligne. Vérifiez votre connexion internet.",
    timeout: "La requête a expiré. Veuillez réessayer.",
    serverError: "Erreur serveur. Veuillez réessayer plus tard."
  },
  authentication: {
    title: "Erreur d'authentification",
    unauthorized: "Vous n'êtes pas autorisé à accéder à cette ressource.",
    sessionExpired: "Votre session a expiré. Veuillez vous reconnecter.",
    invalidCredentials: "Identifiants invalides.",
    forbidden: "Accès interdit."
  },
  validation: {
    required: "Ce champ est requis",
    invalidEmail: "Adresse email invalide",
    invalidFormat: "Format invalide",
    minLength: "Longueur minimale : {{min}} caractères",
    maxLength: "Longueur maximale : {{max}} caractères",
    minValue: "Valeur minimale : {{min}}",
    maxValue: "Valeur maximale : {{max}}"
  },
  notFound: {
    title: "Page non trouvée",
    message: "La page que vous recherchez n'existe pas.",
    goHome: "Retour à l'accueil"
  },
  api: {
    "400": "Requête invalide",
    "401": "Non autorisé",
    "403": "Accès interdit",
    "404": "Ressource non trouvée",
    "500": "Erreur serveur interne",
    "503": "Service temporairement indisponible"
  }
};
